import {
  faCalendarAlt,
  faFilter,
  faSearch,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "components/base/DatePicker";
import { differenceInDays, format } from "date-fns";
import { Button, Form, Offcanvas } from "react-bootstrap";

export default function FiltroOffCanva({
  isShow,
  onClose,
  dataInicial,
  setDataInicial,
  dataFinal,
  setDataFinal,
}: {
  isShow: boolean;
  onClose: () => void;
  dataInicial: string | undefined;
  setDataInicial: (date: string | undefined) => void;
  dataFinal: string | undefined;
  setDataFinal: (date: string | undefined) => void;
}) {
  return (
    <Offcanvas
      show={isShow}
      onHide={onClose}
      placement="end"
      backdrop="static"
      className="filtro-offcanvas"
      style={{
        maxWidth: "400px",
        boxShadow: "-5px 0 25px rgba(0,0,0,0.1)",
      }}
    >
      <Offcanvas.Header closeButton className="border-bottom pb-3">
        <Offcanvas.Title>
          <div className="d-flex align-items-center">
            <div
              className="d-flex align-items-center justify-content-center me-3"
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #4e73df 0%, #6610f2 100%)",
                boxShadow: "0 2px 10px rgba(70, 115, 223, 0.2)",
              }}
            >
              <FontAwesomeIcon icon={faFilter} className="text-white" />
            </div>
            <h5 className="mb-0 fw-bold">Filtros Avançados</h5>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-4 d-flex flex-column bg-body-highlight">
        <Form className="flex-grow-1">
          <div className="filter-section mb-4 p-3 rounded-3 bg-body-emphasis">
            <h6
              className="text-uppercase mb-3 d-flex align-items-center"
              style={{
                fontSize: "0.75rem",
                letterSpacing: "1px",
                color: "#6c757d",
                fontWeight: "600",
              }}
            >
              <FontAwesomeIcon
                icon={faCalendarAlt}
                className="me-2"
                style={{ fontSize: "0.75rem" }}
              />
              Período de Data
            </h6>

            <Form.Group className="mb-4">
              <Form.Label className="fw-medium">Data Inicial</Form.Label>
              <div className="position-relative">
                <DatePicker
                  value={dataInicial}
                  onChange={(date) => setDataInicial(date[0] as any)}
                />
              </div>
              <small className="text-muted mt-1 d-block">
                {dataInicial &&
                  `Data selecionada: ${format(new Date(dataInicial), 'dd/MM/yyyy')}`}
                {!dataInicial && "Selecione a data inicial do período"}
              </small>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="fw-medium">Data Final</Form.Label>
              <div className="position-relative">
                <DatePicker
                  value={dataFinal}
                  onChange={(date) => setDataFinal(date[0] as any)}
                />
              </div>
              <small className="text-muted mt-1 d-block">
                {dataFinal &&
                  `Data selecionada: ${format(new Date(dataFinal), 'dd/MM/yyyy')}`}
                {!dataFinal && "Selecione a data final do período"}
              </small>
            </Form.Group>
          </div>

          {dataInicial && dataFinal && (
            <div
              className="alert d-flex align-items-center bg-body-emphasis"
              style={{
                borderLeft: "4px solid #0d6efd",
                borderRadius: "0.25rem",
                padding: "0.75rem 1rem",
                marginTop: "1rem",
              }}
            >
              <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
              <div>
                Período selecionado:{" "}
                <strong>{format(new Date(dataInicial), 'dd/MM/yyyy')}</strong> até{" "}
                <strong>{format(new Date(dataFinal), 'dd/MM/yyyy')}</strong>
                <div className="small mt-1">
                  Total de{" "}
                  {differenceInDays(new Date(dataFinal), new Date(dataInicial)) + 1} dias
                </div>
              </div>
            </div>
          )}
        </Form>

        <div className="d-flex flex-column gap-2 p-3 border-top pt-3 mt-auto bg-body-emphasis">
          <Button
            variant="primary"
            onClick={onClose}
            className="d-flex align-items-center justify-content-center py-2 fw-medium"
            style={{
              background: "linear-gradient(135deg, #4e73df 0%, #6610f2 100%)",
            }}
          >
            <FontAwesomeIcon icon={faSearch} className="me-2" />
            Aplicar Filtros
          </Button>
          <Button
            variant="light"
            onClick={() => {
              setDataInicial(undefined);
              setDataFinal(undefined);
            }}
            className="d-flex align-items-center justify-content-center py-2 fw-medium"
          >
            <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
            Limpar Filtros
          </Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
